import { ToastContainer, ToastOptions } from "react-toastify";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";

interface ToastProps {
  isFail?: boolean;
}

const IconComponent = ({ type }: ToastOptions): React.ReactElement => {
  return type === "error" ? (
    <FailIcon className="material-icons-outlined">cancel</FailIcon>
  ) : (
    <CheckIcon className="material-icons-outlined">check_circle</CheckIcon>
  );
};

export default function Toast({ isFail }: ToastProps) {
  return (
    <StyledToastContainer
      isFail={isFail}
      position="top-center"
      autoClose={2000}
      hideProgressBar={true}
      closeOnClick={true}
      pauseOnHover={true}
      draggable={true}
      icon={<IconComponent type="error" />} // JSX 요소로 전달
      closeButton={
        <CloseIcon className="material-icons-outlined">clear</CloseIcon>
      }
    />
  );
}

const StyledToastContainer = styled(ToastContainer)<ToastProps>`
  .Toastify__toast {
    width: 420px;
    min-height: 60px;
    border-radius: 15px;
    background-color: ${({ isFail, theme }) =>
      isFail ? theme.buttonColor.redNormal : theme.color.gray900};
  }

  .Toastify__toast--error {
    width: 420px;
    min-height: 60px;
    border-radius: 15px;
    background-color: ${({ theme }) => theme.buttonColor.redNormal};
  }

  .Toastify__toast-body {
    font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo",
      Pretendard Variable, Roboto, "Noto Sans KR", "Segoe UI", "Malgun Gothic",
      sans-serif;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 21px !important;
    text-align: left;
    color: #ffffff;
  }

  .Toastify__toast-container--top-center {
    top: 44px;
  }

  .Toastify__toast-container {
    padding: 0;
  }
`;

const CloseIcon = styled.span`
  color: white;
  display: flex;
  align-items: center;
  padding-right: 8px;
`;

const CheckIcon = styled.span`
  color: #00c7c7;
`;

const FailIcon = styled.span`
  color: ${({ theme }) => theme.color.white};
`;
